import { createReducer, on } from '@ngrx/store';
import { lessonActions } from '../actions/lesson.actions';
import { Lesson } from '../models';
import { BaseState, StateManager } from '@app/store/shared';

export interface LessonState {
    items: Record<string, BaseState<Lesson>>;
}

export const initialState: LessonState = {
    items: {},
};

export const lessonReducer = createReducer(
    initialState,
    on(lessonActions.getLesson, (state, payload): LessonState => {
        if (state.items[payload.id] === undefined) {
            return {
                ...state,
                items: {
                    ...state.items,
                    [payload.id]: StateManager.initial(true),
                },
            };
        }

        return state;
    }),
    on(lessonActions.getLessonSuccess, (state, { lesson }): LessonState => {
        return {
            ...state,
            items: {
                ...state.items,
                [lesson.id]: StateManager.setLoaded(state.items[lesson.id], lesson),
            },
        };
    }),
    on(
        lessonActions.getLessonError,
        (state, { id }): LessonState => ({
            ...state,
            items: {
                ...state.items,
                [id]: StateManager.setError(state.items[id]),
            },
        }),
    ),
    on(
        lessonActions.clear,
        (): LessonState => ({
            ...initialState,
        }),
    ),
);
